module.exports = __webpack_public_path__ + "media/images/icon02-29754faa3e2c50ea4a2a6f0a0d2b8780.png";